import { Download, Loader2, X } from 'lucide-react'
import { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
let installPrompt = null as any
const DownloadContainer = () => {
  const [showContainer, setShowContainer] = useState(false)
  const [loading, setLoading] = useState(false)
  const {pathname}  = useLocation()
  
  useEffect(() => {
    const installButton = document.querySelector('#install') as any
    window.addEventListener('beforeinstallprompt', (event) => {
      event.preventDefault()
      installPrompt = event
      setShowContainer(true)
    })
    installButton.addEventListener('click', async () => {
      try {
        setLoading(true)
        if (!installPrompt) {
          return
        }
        const result = await installPrompt.prompt()
        console.log(`Install prompt was: ${result.outcome}`)
        setShowContainer(true)
      } catch (error) {
      } finally {
        setLoading(false)
      }
    })
  }, [])
  return (
    <div
      id="install_container"
      role="dialog"
      aria-live="polite"
      className={[
        'fixed bottom-2 md:bottom-10 left-1/2 -translate-x-1/2 z-50',
        'w-[calc(100%-16px)] md:w-[364px]',
        'rounded-2xl bg-white text-neutral-900',
        // elevation: strong but soft shadow + hairline ring
        'shadow-[0_14px_40px_-10px_rgba(0,0,0,0.35)] ring-1 ring-black/5',
        'px-3 md:px-4 py-3 md:py-3',
        'flex items-center gap-3 md:gap-4 transition-all duration-200',
      ].join(' ')}
      style={{
        ...((!showContainer||pathname!=='/dashboard') && { transform: 'translate(-50%, 200%)' }),
      }}
    >
      {/* CTA button */}
      <button
        id="install"
        className="kl-touch shrink-0 inline-flex items-center gap-2 rounded-full px-4 py-2 font-semibold text-white
               bg-[#f96900] hover:bg-[#e96000] active:bg-[#d85700] transition
               shadow-[0_6px_18px_-6px_rgba(249,105,0,0.6)]"
      >
        {loading ? <Loader2 className="animate-spin" /> : <Download className="opacity-95" />}
        <span className='text-white'>Install</span>
      </button>

      {/* Copy */}
      <div className="min-w-0 flex-1">
        <div className="text-sm md:text-base font-semibold leading-tight">Cray, one tap away</div>
        <div className="text-xs text-neutral-600">Faster access, surprise perks</div>
      </div>

      {/* Dismiss */}
      <button
        aria-label="Dismiss install banner"
        onClick={() => setShowContainer(false)}
        className="kl-touch w-8 h-8 grid place-items-center rounded-full hover:bg-neutral-100 active:bg-neutral-200 transition"
      >
        <X className="w-5 h-5" />
      </button>
    </div>
  )
}
export default DownloadContainer
